<mat-card>
    <h4 class="text-center">Cancellations vs Bookings</h4>
    <div style="height: 350px">
        <canvas id="assessmentScores"></canvas>
    </div>
</mat-card>
